// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__ChaiU","modal":"modal_modal__CkJcn","slide-down":"modal_slide-down__TRe75"};